import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1vh;
`;

interface ContainerConteudoProps {
  children: any;
}

function WorkspaceFicha(props: ContainerConteudoProps) {
  return <Container>{props.children}</Container>;
}

export default WorkspaceFicha;
